/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core'
import { IAppState } from '@app/models/app-state'
import { IFormData } from '@app/models/form-data'
import { WorkflowStep } from '@models/workflow-step'
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class StoreService {
	/** Application State */
	public previousWorkflowStep?: WorkflowStep
	private readonly _workflowState: BehaviorSubject<number> = new BehaviorSubject(WorkflowStep.VetClinic)
	public readonly workflowState$: Observable<WorkflowStep> = this._workflowState.asObservable()
	/** Application State */
	private readonly _appState: BehaviorSubject<IAppState> = new BehaviorSubject(<IAppState>{})
	public readonly appState$: Observable<IAppState> = this._appState.asObservable()
	/** Form state */
	private readonly _formState: BehaviorSubject<IFormData> = new BehaviorSubject(<IFormData>{})
	public readonly formState$: Observable<IFormData> = this._formState.asObservable()

	constructor() {}

	public async updateWorkflowStep(payload: WorkflowStep): Promise<void> {
		this.previousWorkflowStep = await firstValueFrom(this.workflowState$)
		this._workflowState.next(payload)
	}

	public async updateAppState(payload: Partial<IAppState>): Promise<void> {
		const state: IAppState = await firstValueFrom(this.appState$)
		const updatedState: IAppState = {
			...state,
			...payload,
		}
		this._appState.next(updatedState)
	}

	public async updateFormState(payload: Partial<IFormData>): Promise<void> {
		const state: IFormData = await firstValueFrom(this.formState$)
		const updatedState: IFormData = {
			...state,
			...payload,
		}
		this._formState.next(updatedState)
	}

	public cleanupFormState(): void {
		this._formState.next(<IFormData>{})
	}

	/** Used **ONLY** for the back button from other-owners to the vet clinic form it came from */
	public navigateToPreviousStep(): void {
		this.updateWorkflowStep(!!this.previousWorkflowStep ? this.previousWorkflowStep : WorkflowStep.VetClinic)
	}
}
